import React, { useMemo } from "react";
import { IconButton } from "@mui/material";
import ProTable from "design-system/ProTable";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router";
import { formatToRupees } from "utlis/utils";
import { startCase, toLower } from "lodash";

function ClaimsTable({ headers, rows }) {
  const navigate = useNavigate();

  const truncateString = (str, length) => {
    return str.length > length ? str.slice(0, length) + "..." : str;
  };

  const capitalizeFields = (row) => {
    const fieldsToCapitalize = ["claim_status", "claim_type", "patient_name"];
    return Object.entries(row).reduce((acc, [key, value]) => {
      if (fieldsToCapitalize.includes(key) && typeof value === "string") {
        acc[key] = startCase(toLower(value));
      } else if (key === "claim_number" && typeof value === "string") {
        acc[key] = truncateString(value, 12);
      } else {
        acc[key] = value;
      }
      return acc;
    }, {});
  };

  const redirectToEmployeeClaimsDetail = (employeeId) => {
    navigate(`/v1/claims/mis/${employeeId}`);
  }

  const alteredRows = useMemo(() => {
    if (!rows || rows.length === 0) return [];

    return rows.map((row) => {
      const { id, claim_amount, ...rest } = row;
      const employeeId = id;
      const capitalizedRest = capitalizeFields(rest);

      return {
        ...capitalizedRest,
        claim_amount: claim_amount !== "0" ? formatToRupees(claim_amount) : "-",
        arrow: (
          <IconButton
            onClick={() => redirectToEmployeeClaimsDetail(employeeId)}
            sx={{
              background: "rgba(0, 0, 0, 0.04)",
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        ),
      };
    });
  }, [rows]);

  const alteredHeaders = useMemo(() => {
    if (!headers || headers.length === 0) return [];
    const updatedHeaders = headers.slice(1);
    return updatedHeaders.concat([
      {
        name: "arrow",
        display_name: "",
        style: {
          width: "60px",
        },
      },
    ]);
  }, [headers]);

  return <ProTable headers={alteredHeaders} rows={alteredRows} />;
}

export default ClaimsTable;
